/**
 * One definition per counted quantity (#613, PO 28.10.2026 "Eine Zahlenwahrheit"): the same set shows the same number
 * on every page; a subset is only shown next to its total and named as a subset. Totals come from the backend:
 * - open cases: booking-case.service listOpen().openTotal (GET /api/booking-cases -> openTotal). Messages tab "Offen gesamt"
 *   and the Heute tile "Gäste-Nachrichten" show the same total; the tile rows are the subset "offen heute".
 * - open tasks (PO 28.10.2026 Variante A): open ledger tasks (pm_tasks + booking-item tasks) + callbacks + mail tasks + price
 *   checks + bot booking requests, one set from dashboard-read.service openTasks (GET /api/dashboard/open-tasks -> openTotal),
 *   filtered by the house selection in the backend (`locations`, rows without a known house stay under "ohne-standort").
 *   Aufgaben "Offen gesamt" and the Heute tile "Offene Aufgaben" show this total; FAQ questions are a named extra.
 *   For a selected day other than today the tile may differ: the non-ledger sources are read as of that day.
 * - urgent: its own named subset, urgentRows() in Urgency.tsx.
 * - Haus tile: header = occupied units of the selected houses (of N units); the line counts the bookings of the day by kind.
 */
export const MEASURES = {
  openCasesAll: 'Offen gesamt',
  openCasesToday: 'offen heute',
  urgent: 'dringend',
  tasksTotal: 'offen gesamt',
  units: 'Einheiten',
  unitsOccupied: 'belegt',
  bookingsByKind: 'Buchungen',
} as const;

/** "1 Einheit" / "N Einheiten". */
export const unitsText = (count: number) => `${count} ${count === 1 ? 'Einheit' : MEASURES.units}`;
/** An exact total, or "mind. N" when the backend read was cut off. */
export const totalText = (count: number, truncated?: boolean) => `${truncated ? 'mind. ' : ''}${count}`;
